var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "custom-header__container" },
        [
          _c(
            "page-header",
            {
              staticStyle: { flex: "1" },
              attrs: {
                actions: _vm.pageHeaderActionsConfig,
                "left-side-class": "mb-0 col-md-6",
                page: _vm.pageHeaderConfig,
                "right-side-class":
                  "col-sm-12 col-md-6 align-items-end d-flex pb-2 justify-content-end"
              }
            },
            [
              _c("div", { staticClass: "d-flex" }, [
                _vm.canDetermineProposalRequest && !_vm.showDetermination
                  ? _c("div", [
                      _vm.canDetermineProposalRequest
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-dropdown-actions w-100 dropdown-toggle float-left color-white bg-green font-weight-bold d-flex justify-content-center align-items-center",
                              attrs: {
                                "aria-expanded": "false",
                                "aria-haspopup": "true",
                                "data-toggle": "dropdown",
                                type: "button"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-flag-alt mx-2 pr-1 mt-2"
                              }),
                              _c("span", { staticClass: "mr-1" }, [
                                _vm._v("Determinar")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "dropdown-menu dropdown-menu-right custom-dropdown-container",
                          attrs: { "aria-labelledby": "dropdownMenuButton" }
                        },
                        [
                          _vm.canRecommendProposalRequest
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-item cursor-pointer mb-1",
                                  on: {
                                    click: function($event) {
                                      return _vm.onOpenDeterminationHandler(
                                        _vm.proposalRequestStatus.Recommended
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-check text-green mr-2"
                                  }),
                                  _vm._v(" Recomendar ")
                                ]
                              )
                            : _vm._e(),
                          _vm.isProvisionalRemedy &&
                          _vm.canRecommendProposalRequest &&
                          _vm.IsPartialRecomendationStatus
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-item cursor-pointer mb-1",
                                  on: {
                                    click: function($event) {
                                      return _vm.onOpenDeterminationHandler(
                                        _vm.proposalRequestStatus
                                          .PartialRecommendation
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-check text-yellow mr-2"
                                  }),
                                  _vm._v(" Recomendado Parcial ")
                                ]
                              )
                            : _vm._e(),
                          _vm.canNotRecommendProposalRequest
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-item cursor-pointer mb-1",
                                  on: {
                                    click: function($event) {
                                      return _vm.onOpenDeterminationHandler(
                                        _vm.proposalRequestStatus.NotRecommended
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-times-circle text-red mr-2"
                                  }),
                                  _vm._v(" No Recomienda ")
                                ]
                              )
                            : _vm._e(),
                          _vm.isProvisionalRemedy
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-item cursor-pointer mb-1",
                                  on: {
                                    click: function($event) {
                                      return _vm.onOpenDeterminationHandler(
                                        _vm.proposalRequestStatus
                                          .RequirementsDoesNotAccomplish
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-times-circle text-red mr-2"
                                  }),
                                  _vm._v(" No Cumple Requisitos ")
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      ),
      _vm.showDetermination
        ? _c("proposal-request-determination", {
            staticClass: "mb-3",
            attrs: {
              "determination-status-id": _vm.determinationStatusId,
              "is-for-reset-determination": _vm.isForResetDetermination,
              "proposal-request-id": Number(_vm.proposalRequestId),
              "proposal-request-number": _vm.proposalRequest.proposalNumber
            },
            on: {
              "on-cancel": _vm.onCancelDeterminationHandler,
              saved: _vm.onSavedDeterminationHandler
            }
          })
        : _vm._e(),
      _vm.toggleStatusCard && _vm.proposalRequestStatusTransitions.length > 0
        ? _c("status-transition", {
            attrs: {
              statuses: _vm.proposalRequestStatusTransitions,
              title: "Cambiar Estatus"
            },
            on: {
              "on-close": function($event) {
                _vm.toggleStatusCard = false
              },
              "on-continue": _vm.onSwitchStatus
            }
          })
        : _vm._e(),
      _vm.showRecommendPanel
        ? _c("recommend-evaluation", {
            attrs: {
              "final-score": _vm.score,
              "proposal-request-id": Number(_vm.proposalRequestId),
              "proposal-request-status": _vm.recommendationPanelOptions
            },
            on: {
              "on-cancel": _vm.onRecommendedEvaluationCancel,
              "on-proposal-status-change": _vm.onProposalStatusChange
            }
          })
        : _vm._e(),
      _c("board", { staticClass: "mb-4", attrs: { details: _vm.boardConfig } }),
      _c(
        "q-tab",
        {
          attrs: {
            "active-tab": _vm.currentIndexTab,
            "nav-class": "text-nowrap"
          }
        },
        [
          _vm.isProponentOrSupplier || _vm.canViewProposalTabs
            ? _c(
                "q-tab-item",
                {
                  attrs: {
                    active: "",
                    lazy: "",
                    tabindex: 0,
                    title: "Perfil Proponente"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(
                        _vm.detailsInfoTabs.PerfilProponente
                      )
                    }
                  }
                },
                [
                  _c("profile-tab", {
                    attrs: {
                      "can-view-contract-info": _vm.canViewContractInfo,
                      "proposal-request-id": Number(_vm.proposalRequestId),
                      "proposal-request-info": _vm.proposalRequest
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showProposalDetailTab
            ? _c(
                "q-tab-item",
                {
                  attrs: {
                    active:
                      _vm.currentIndexTab ===
                      _vm.detailsInfoTabs.DetallePropuesta,
                    lazy: "",
                    tabindex: 1,
                    title: "Detalles de la Propuesta"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(
                        _vm.detailsInfoTabs.DetallePropuesta
                      )
                    }
                  }
                },
                [
                  _c("proposal-details", {
                    attrs: { "proposal-request-id": _vm.proposalRequestId }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.canViewProposalTabs
            ? _c(
                "q-tab-item",
                {
                  attrs: {
                    active:
                      _vm.currentIndexTab ===
                      _vm.detailsInfoTabs.DocumentosPropuesta,
                    lazy: "",
                    tabindex: 2,
                    title: "Documentos Propuesta"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(
                        _vm.detailsInfoTabs.DocumentosPropuesta
                      )
                    }
                  }
                },
                [
                  _c("proposal-documents-tab", {
                    attrs: {
                      bus: _vm.bus,
                      "can-submit-amendmnet": _vm.showSubmitAmendmentBtn,
                      "proposal-request-id": Number(_vm.proposalRequestId)
                    },
                    on: { "on-proposal-status-change": _vm.getProposalRequest }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showEvaluationTab
            ? _c(
                "q-tab-item",
                {
                  attrs: {
                    active:
                      _vm.currentIndexTab === _vm.detailsInfoTabs.Evaluation,
                    lazy: "",
                    tabindex: 3,
                    title: "Evaluación"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(_vm.detailsInfoTabs.Evaluation)
                    }
                  }
                },
                [
                  _c("evaluators-tab", {
                    attrs: {
                      "academic-year-id": _vm.academicYearId,
                      bus: _vm.bus,
                      "proposal-request-id": Number(_vm.proposalRequestId),
                      "rubric-id": _vm.rubricId
                    },
                    on: {
                      ready: _vm.onEvaluationLoad,
                      refresh: _vm.refreshInfo,
                      "score-change": _vm.onScoreChange
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showContractTab
            ? _c(
                "q-tab-item",
                {
                  attrs: {
                    active:
                      _vm.currentIndexTab === _vm.detailsInfoTabs.Contratacion,
                    lazy: "",
                    tabindex: 4,
                    title: "Contratación"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(_vm.detailsInfoTabs.Contratacion)
                    }
                  }
                },
                [
                  _c("contrat-tab", {
                    attrs: {
                      "proposal-request-id": Number(_vm.proposalRequestId)
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showSeparationFunds
            ? _c(
                "q-tab-item",
                {
                  attrs: {
                    active:
                      _vm.currentIndexTab ===
                      _vm.detailsInfoTabs.SeparationFondos,
                    lazy: "",
                    tabindex: 5,
                    title: "Separación Fondos"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(
                        _vm.detailsInfoTabs.SeparationFondos
                      )
                    }
                  }
                },
                [
                  _c("separation-of-funds", {
                    ref: "separationOfFunds",
                    attrs: {
                      "fiscal-year-id": this.proposalRequest.academicYearId,
                      "proposal-request-id": Number(_vm.proposalRequestId),
                      "proposal-request-info": _vm.proposalRequest
                    },
                    on: { refresh: _vm.refreshInfo }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showContractDocumentTab
            ? _c(
                "q-tab-item",
                {
                  attrs: {
                    active:
                      _vm.currentIndexTab ===
                      _vm.detailsInfoTabs.DocumentosContrato,
                    lazy: "",
                    tabindex: 6,
                    title: "Documentos de Proveedor"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(
                        _vm.detailsInfoTabs.DocumentosContrato
                      )
                    }
                  }
                },
                [
                  _c("contract-documents-tab", {
                    attrs: {
                      bus: _vm.bus,
                      "proposal-request-id": Number(_vm.proposalRequestId),
                      "show-submit": _vm.showSubmitDocumentButton
                    },
                    on: { validateStatus: _vm.getAllSubmitContractDocuments }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "q-tab-item",
            {
              attrs: {
                active: _vm.currentIndexTab === _vm.detailsInfoTabs.Bitácora,
                lazy: "",
                tabindex: 7,
                title: "Bitácora"
              },
              on: {
                click: function($event) {
                  return _vm.onActiveTab(_vm.detailsInfoTabs.Bitácora)
                }
              }
            },
            [_c("bitacora-manager")],
            1
          ),
          _vm.canViewProposalTabs
            ? _c(
                "q-tab-item",
                {
                  attrs: {
                    active:
                      _vm.currentIndexTab === _vm.detailsInfoTabs.Historial,
                    lazy: "",
                    tabindex: 8,
                    title: "Historial"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(_vm.detailsInfoTabs.Historial)
                    }
                  }
                },
                [
                  _c("historial-tab", {
                    attrs: {
                      "proposal-request-id": Number(_vm.proposalRequestId)
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }